// const environment = {
//     config:{
//         apiBaseUrl:"https://www.divandsection.com/ghoomoworldservices/api/",
//         apiOrderUrl:'https://www.divandsection.com/ghoomoorderservices/api/',
//     }
// }

// export default environment;



//Live server
const environment = {
    config:{
        apiBaseUrl:"https://ghoomoworld.com/ghoomoworldservices/api/",
        apiOrderUrl:'https://ghoomoworld.com/ghoomoorderservices/api/',
    }
}

export default environment;